import { SHIPPING_COUNTRY_CODES } from "@/data/shipping-country-code"
import { CENTRA_LANGUAGE_CODE } from "@/data/supported-languages"
import { type RobotsMeta } from "@/lib/utils/seo/robots"

export const FREE_SHIPPING_VOUCHER_CODE = "free-shipping-for-poc-members"
export const inBrowser = typeof window !== "undefined"
export const isIOS =
    inBrowser && window.CSS && CSS.supports("-webkit-overflow-scrolling: touch")
export const isSafari =
    inBrowser && /^((?!chrome|android).)*safari/i.test(navigator.userAgent)
export const DEFAULT_USER_COUNTRY_CODE = SHIPPING_COUNTRY_CODES.Germany // used in middleware and where we use next headers country code
export const siteUrl = process.env.NEXT_PUBLIC_SITEMAP_DOMAIN || "https://localhost:3000"
export const UNIVERSAL_DEFAULT_LANGUAGE =
    process.env.FALLBACK_DEFAULT_LANGUAGE ?? CENTRA_LANGUAGE_CODE.En
export const EXCLUDE_ABSOLUTE_PATH_GENERATION_FOR_SITE_SELECTOR_LINKS = [
    "cart",
    "checkout",
    "payment-failed",
    "payment-result"
]
export const PFAS_COUNTRY = "US"
export const DEPICT_MAX_FETCH_LIMIT = 250 // Max fetch limit for depict products in a single request
export const COOKIE_MAX_AGE = 60 * 60 * 24 * 365 // 365 days

export const NEXT_NOT_FOUND_ERROR = "NEXT_NOT_FOUND" // Used to identify Next.js not found errors

export const ROBOTS_META_VALUES: Record<string, RobotsMeta> = {
    indexfollow: {
        index: true,
        follow: true
    },
    indexnofollow: {
        index: true,
        follow: false
    },
    noindexfollow: {
        index: false,
        follow: true
    },
    noindexnofollow: {
        index: false,
        follow: false
    }
}

export const JOURNAL_SLUG = "journal"
export const PRESSROOM_SLUG = "pressroom"

export const HEADER_MARGIN_TOP = "mt-48 temp-md:mt-56"
export const MOBILE_MAX_VIEW_WIDTH = 639
export const TABLET_MAX_VIEW_WIDTH = 967 // TODO update to 1023 when breakpoints are updated

// Used in product schema
export const TRANSIT_DAYS_BY_PRICELIST = {
    czk: { min: 2, max: 5 },
    dkk: { min: 2, max: 5 },
    eur: { min: 2, max: 7 }, // covers UPS Express 2–3, Standard 3–7, DPD 3–5
    pln: { min: 2, max: 5 },
    sek: { min: 2, max: 5 },
    jpy: { min: 5, max: 10 },
    usd: { min: 2, max: 7 }, // mix of 2-Day, 3-Day, Ground up to 7
    cad: { min: 5, max: 8 },
    chf: { min: 3, max: 7 },
    gbp: { min: 5, max: 8 },
    nok: { min: 3, max: 8 },
    aud: { min: 2, max: 6 }, // Parcel Post 2–6
    nzd: { min: 2, max: 7 }
} as const

// Used in product schema
export const HANDLING_DAYS = { min: 1, max: 2 } as const

// Checkout constants
export const PAYMENT_RESULT_URL = "payment-result" // used in payment scripts return url
export const PAYMENT_FAILED_URL = "payment-failed" // used in payment scripts error url
export const UNAVAILABLE_ITEMS_TYPE = "unavailable items" // used in modal popup
export const baseUrl = typeof window !== "undefined" ? window.location.origin : "" // used in payment scripts base url
export const successUrl = `${baseUrl}/api/centra/${PAYMENT_RESULT_URL}` // used in payment scripts success url
export const MAX_VOUCHERS = 3

// styling
export const activeStepClasses = "text-col-text-primary"
export const inactiveStepClasses = "text-col-text-tertiary"
export const outerStepClasses = "border-b border-col-border"
export const innerStepClasses = "flex h-full flex-col px-12 md:px-24 lg:px-32"

// Session storage keys
export const CHECKOUT_CUSTOMER_INFO_STORAGE_KEY = "checkout_customer_info" //sessionStorage key for checkout customer info
export const SAME_SHIPPING_ADDRESS_STORAGE_KEY = "same_shipping_address" //sessionStorage key for same shipping address
export const USER_HAS_SELECTED_STATE_STORAGE_KEY = "user_has_selected_state" //sessionStorage key for user has selected state
export const FIRST_INIT_CHECKOUT_STORAGE_KEY = "first_init_checkout" //sessionStorage key for first init checkout
export const VERIFIED_SHIPPING_ADDRESS_STORAGE_KEY = "verified_shipping_address" //sessionStorage key for the shipping address Loqate has already settled

export const REQUIRED_FIELDS = [
    "city",
    "firstName",
    "lastName",
    "zipCode",
    "phoneNumber",
    "address1",
    "email",
    "country"
]
// End of Checkout constants
